module.exports = __webpack_public_path__ + "logo.c62b1b6.png";